'use client'

import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useDebounce } from '@uidotdev/usehooks'
import { useEffect, useState, useCallback } from 'react'
import { useKeyDateStore } from '@repo/store/useKeyDateStore'
import PropTypes from 'prop-types'

export const KeyDateTypeSelect = ({
  testData = null,
  value = null,
  label = null,
  onChange = (val) => {
    console.log(val)
  },
  sx,
  size = 'small',
  required,
  errors = {},
  name = 'keyDateType',
  keyDateTable = false
}) => {
  const pageSize = 25
  const { fetchKeyDateTypes } = useKeyDateStore()
  const [options, setOptions] = useState(testData || [])
  const [totalRowCount, setTotalRowCount] = useState(pageSize)
  const [startAtIndex, setStartAtIndex] = useState(0)
  const [selectedValue, setSelectedValue] = useState(value)
  const [searchTerm, setSearchTerm] = useState('')
  const debouncedSearchTerm = useDebounce(searchTerm, 400)

  const fetchKeyDateTypesFromApi = useCallback(
    async ({ appendResults, startAt }) => {
      const { rows, totalRowCount } = await fetchKeyDateTypes({
        startAtIndex: startAt,
        pageSize,
        description: debouncedSearchTerm
      })

      setStartAtIndex(startAt)
      setTotalRowCount(totalRowCount)
      setOptions(appendResults ? [...options, ...rows] : [...rows])
    },
    [fetchKeyDateTypes, debouncedSearchTerm, options]
  )

  useEffect(() => {
    setSelectedValue(value)
  }, [value])

  useEffect(() => {
    if (testData) return
    fetchKeyDateTypesFromApi({ appendResults: false, startAt: 0 })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testData])

  useEffect(() => {
    fetchKeyDateTypesFromApi({ appendResults: false, startAt: 0 })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchTerm])

  const handlePagination = () => {
    const hasMorePages = totalRowCount > options?.length
    if (!hasMorePages) return

    const newStartAtIndex = startAtIndex + pageSize
    fetchKeyDateTypesFromApi({ appendResults: true, startAt: newStartAtIndex })
  }

  const KeyDateTableSx = keyDateTable
    ? {
        [`& > div > div`]: {
          backgroundColor: 'transparent',
          minHeight: 0,
          height: '33px',
          mt: '3px'
        },
        [`& .MuiInputLabel-shrink`]: {
          background: '#f5f6f8 !important'
        },
        [`& > div > div > div`]: {
          height: '30px'
        }
      }
    : null

  return (
    <div data-testid="KeyDateTypeSelect" style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%' }}>
      <ReactSelectMenu
        label={label ?? 'Key date type'}
        onChange={(newVal) => {
          onChange(newVal)
          setSelectedValue(newVal)
        }}
        labelKey="description"
        valueKey="keyDateTypeId"
        items={options}
        value={selectedValue}
        searchable
        idLabelKey="keyDateTypeId"
        showIdInResults
        name={name}
        size={size}
        required={required}
        errors={errors}
        onAtBottom={handlePagination}
        onSearchTermChange={setSearchTerm}
        menuZindex={9999999}
        sx={KeyDateTableSx}
      />
    </div>
  )
}

KeyDateTypeSelect.propTypes = {
  testData: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  onChange: PropTypes.func,
  sx: PropTypes.object,
  size: PropTypes.string,
  required: PropTypes.bool,
  errors: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  keyDateTable: PropTypes.bool
}
